/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleFilled = createReactComponent("circle-filled", "IconCircleFilled", [
  [
    "path",
    {
      d: "M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z",
      fill: "currentColor",
      key: "svg-0",
      strokeWidth: "0"
    }
  ]
]);

export { IconCircleFilled as default };
//# sourceMappingURL=IconCircleFilled.js.map
